<template>
    <div class="moment">
        <img v-if="result.picture" :src="result.picture.src" :alt="result.picture.alt">
        <div class="moment__footer">
            <h5 v-if="result.name" class="def-title-5">
                <a  v-if="result.detailPage && result.name" :href="result.detailPag">{{result.name}}</a>
            </h5>
            <p class="moment__counter">
                {{result.text}}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'choice-ring-card',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "name":"весілля",
                    "text":"3 890 обручок",
                    "detailPage":"/blog/test-2/",
                    "picture": {
                        "alt":"Test 2",
                        "src":"/local/templates/love-you/images/front-end/blog/blog-6.png"
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .choice-ring-card{

    }
</style>